import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { SITE_CONFIG } from '../config';

const LanguageContext = createContext(null);
const LANGUAGE_STORAGE_KEY = 'houseitgoing-language-preference';

const copy = {
  en: {
    languageName: 'Español', home: 'Home', search: 'Search homes', about: 'Meet the Team',
    areas: 'Areas', guides: 'Guides', reviews: 'Reviews', journal: 'Journal', contact: 'Contact',
    call: 'Call Giovanni', email: 'Email Giovanni', back: 'Back to home', readMore: 'Read guide',
    explore: 'Explore', helpful: 'Helpful resources', viewHomes: 'View homes', workTogether: 'Let’s talk',
    privacy: 'Privacy', terms: 'Terms', api: 'API', loading: 'Loading…'
  },
  es: {
    languageName: 'English', home: 'Inicio', search: 'Buscar casas', about: 'Conozca al equipo',
    areas: 'Áreas', guides: 'Guías', reviews: 'Reseñas', journal: 'Artículos', contact: 'Contacto',
    call: 'Llamar a Giovanni', email: 'Escribir a Giovanni', back: 'Volver al inicio', readMore: 'Leer guía',
    explore: 'Explorar', helpful: 'Recursos útiles', viewHomes: 'Ver propiedades', workTogether: 'Hablemos',
    privacy: 'Privacidad', terms: 'Términos', api: 'API', loading: 'Cargando…'
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    if (typeof window === 'undefined') return SITE_CONFIG.DEFAULT_LANGUAGE;
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) || SITE_CONFIG.DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    document.documentElement.lang = language;
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }, [language]);

  const value = useMemo(() => ({
    language,
    isSpanish: language === 'es',
    setLanguage,
    toggleLanguage: () => setLanguage((current) => current === 'en' ? 'es' : 'en'),
    t: (key) => copy[language]?.[key] || copy.en[key] || key
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used inside LanguageProvider');
  return context;
}
